export const TREE = 'contactUsModule'

export const CONTACT_US_FORM_SUBMISSION = '@accountsUsModule/CONTACT_US_FORM_SUBMISSION'
